import React from 'react';
import BracketColumn from './BracketColumn';
import ChatBox from './ChatBox';
import './css/Bracket.css'

const games_c1 = [['game1fav', 'game1dog'], ['game2fav', 'game2dog'], ['game3fav', 'game3dog'], ['game4fav', 'game4dog'], ['game5fav', 'game5dog'], ['game6fav', 'game6dog'], ['game7fav', 'game7dog'], ['game8fav', 'game8dog']]
const games_c2 = [['game1fav', 'game1dog'], ['game2fav', 'game2dog'], ['game3fav', 'game3dog'], ['game4fav', 'game4dog']]
const games_c3 = [['game1fav', 'game1dog'], ['game2fav', 'game2dog']]
const games_c4 = [['game1fav', 'game1dog']]
const games_c5 = [['game1fav', 'game1dog']]
const games_c6 = [['game1fav', 'game1dog'], ['game2fav', 'game2dog']]
const games_c7 = [['game1fav', 'game1dog'], ['game2fav', 'game2dog'], ['game3fav', 'game3dog'], ['game4fav', 'game4dog']]
const games_c8 = [['game1fav', 'game1dog'], ['game2fav', 'game2dog'], ['game3fav', 'game3dog'], ['game4fav', 'game4dog'], ['game5fav', 'game5dog'], ['game6fav', 'game6dog'], ['game7fav', 'game7dog'], ['game8fav', 'game8dog']]

function Bracket(){
    return (
        <div id="boxes">
            <div className='page-window'>
                <div className='bracket-section'>
                    <BracketColumn games={games_c1} division="north" />
                    <BracketColumn games={games_c2} />
                    <BracketColumn games={games_c3} />
                    <BracketColumn games={games_c4} />
                    <BracketColumn games={games_c5} />
                    <BracketColumn games={games_c6} />
                    <BracketColumn games={games_c7} />
                    <BracketColumn games={games_c8} division="south" />
                </div>
                <div className='bracket-section'>
                    <BracketColumn games={games_c1} division="west" />
                    <BracketColumn games={games_c2} />
                    <BracketColumn games={games_c3} />
                    <BracketColumn games={games_c4} />
                    <BracketColumn games={games_c5} />
                    <BracketColumn games={games_c6} />
                    <BracketColumn games={games_c7} />
                    <BracketColumn games={games_c8} division="east" />
                </div>
                <div className='bracket-section'>
                    <BracketColumn games={games_c3} />
                    <BracketColumn games={games_c4} />
                    <BracketColumn games={games_c3} />
                </div>
            </div>
            <div className='page-window'>
                <ChatBox></ChatBox>
            </div>
        </div>
    )

}
export default Bracket;